import {useEffect, useState} from "react";
import {useIdentityAuth} from "../context/IdentityAuthContext";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const {login: identityLogin} = useIdentityAuth();

  // Verificar configuración OIDC de Teamsystem al cargar
  useEffect(() => {
    if (!process.env.REACT_APP_TS_OIDC_AUTHORITY) {
      setError("Error: REACT_APP_TS_OIDC_AUTHORITY no está configurado en el archivo .env");
      return;
    }
    if (!process.env.REACT_APP_TS_OIDC_CLIENT_ID) {
      setError("Error: REACT_APP_TS_OIDC_CLIENT_ID no está configurado en el archivo .env");
      return;
    }
    if (!process.env.REACT_APP_TS_OIDC_REDIRECT_URI) {
      setError("Error: REACT_APP_TS_OIDC_REDIRECT_URI no está configurado en el archivo .env");
      return;
    }
    console.log(
      "AUTHORITY",
      process.env.REACT_APP_TS_OIDC_AUTHORITY,
      "CLIENT_ID",
      process.env.REACT_APP_TS_OIDC_CLIENT_ID,
      "REDIRECT_URI",
      process.env.REACT_APP_TS_OIDC_REDIRECT_URI
    );
  }, []);

  // Login con Teamsystem OIDC (redirige a Teamsystem; el callback hace el token exchange)
  const login = async (returnUrl = "/dashboard", options = {}) => {
    try {
      setLoading(true);
      setError("");

      if (!process.env.REACT_APP_TS_OIDC_AUTHORITY || !process.env.REACT_APP_TS_OIDC_CLIENT_ID) {
        throw new Error("Configuración de Teamsystem OIDC incompleta. Revisa tu archivo .env");
      }

      await identityLogin(returnUrl, options);

      return {success: true};
    } catch (error) {
      console.error("Error en login con Teamsystem OIDC:", error);
      let errorMessage = "Error al iniciar sesión con Teamsystem";

      if (error.message?.includes("configuración") || error.message?.includes("REACT_APP")) {
        errorMessage = error.message;
      } else if (error.message?.includes("authority")) {
        errorMessage = "Error en la URL del proveedor OIDC. Verifica REACT_APP_TS_OIDC_AUTHORITY";
      }

      setError(errorMessage);
      return {success: false, error: errorMessage};
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => setError("");

  return {
    login,
    loading,
    error,
    clearError
  };
};

export default useLogin;
